/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const ADD_NEW_CMS_DATA = 'ADD_NEW_CMS_DATA';
export const UPDATE_CMS_TABLE_DATA = 'UPDATE_CMS_TABLE_DATA';
export const VIEW_HISTORY = 'VIEW_HISTORY';
export const CMS_ERROR = 'CMS_ERROR';
export const CMS_EXTRA_STATE = 'CMS_EXTRA_STATE';
export const HANDLE_ERROR_MESSAGE_FOR_CMS = 'HANDLE_ERROR_MESSAGE_FOR_CMS';
export const GET_CMS_TABLE_EDITED_DATA = 'GET_CMS_TABLE_EDITED_DATA';
export const GET_CMS_TABLE_DATA = 'GET_CMS_TABLE_DATA';
export const SET_MAT_DRUG_LIST = 'SET_MAT_DRUG_LIST';
export const SET_MAT_DRUG_SUCCESS = 'SET_MAT_DRUG_SUCCESS';
export const RESET_MAT_DRUG_STORE = 'RESET_MAT_DRUG_STORE';
